import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PaymentTypeEnum } from '../models/payment-type.model';
import { PaymentService } from '../services/payment.service';

@Injectable({ providedIn: 'root' })
export class PaymentTypeResolver implements Resolve<PaymentTypeEnum> {
  constructor(private paymentService: PaymentService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<PaymentTypeEnum> | Promise<PaymentTypeEnum> | PaymentTypeEnum {
    return route.queryParams.type === 'balance' &&
      this.paymentService.payment.balance.enabled !== false &&
      this.paymentService.payment.balance.amountToPay > this.paymentService.payment.amountToPay
      ? PaymentTypeEnum.BALANCE
      : PaymentTypeEnum.LIABILITY;
  }
}
